import React from 'react';
import PropTypes from 'prop-types';

export default function IcUser({ className }) {
  return (
    <svg className={className} fill="none" height="40" viewBox="0 0 40 40" width="40" xmlns="http://www.w3.org/2000/svg">
      <rect fill="#EBF1E1" height="40" rx="15" width="40"/>
      <path d="M25.7545 21.9997C26.9966 21.9997 28.0034 23.0065 28.0034 24.2486V25.167C28.0034 25.7404 27.8242 26.2994 27.4908 26.7659C25.9449 28.9292 23.4206 30.0008 20.0004 30.0008C16.5794 30.0008 14.0564 28.9287 12.5143 26.7643C12.1823 26.2984 12.0039 25.7406 12.0039 25.1685V24.2486C12.0039 23.0065 13.0108 21.9997 14.2528 21.9997H25.7545ZM20.0004 10.0044C22.7618 10.0044 25.0004 12.243 25.0004 15.0044C25.0004 17.7658 22.7618 20.0044 20.0004 20.0044C17.2389 20.0044 15.0004 17.7658 15.0004 15.0044C15.0004 12.243 17.2389 10.0044 20.0004 10.0044Z" fill="#5E811E"/>
    </svg>
  );}

IcUser.propTypes = {
  className: PropTypes.string
};

